"use strict";
import AOS from "aos";

import mobileMenu from "./scripts/mobileMenu";
import shareSocialMidia from "./scripts/shareSocialMidia";
import copyLink from "./scripts/copyLink";
import slideQS from "./scripts/slideQS";
import slidePodcast from "./scripts/slidePodcast";
import headerScrolling from "./scripts/headerScrolling";
import qmSomosScroll from "./scripts/qmSomosScroll";
import traducaoNews from "./scripts/traducaoNews";
import publicidades from "./scripts/publi/publicidades";

AOS.init({
    once: true,
});
//toogleModal();
mobileMenu();
shareSocialMidia();
copyLink();
slideQS();
slidePodcast();
headerScrolling();
qmSomosScroll();
traducaoNews();
//publicidades();

/* ----- PodCast ----- */

import startTurboLinks from "./scripts/podcasts/startTurboLinks";
import podcastPlayer from "./scripts/podcasts/podcastPlayer";

import utils from "./scripts/lib/utils";
import loadSlider from "./scripts/podcasts/loadSlider";
import resizeGridCard from "./scripts/podcasts/resizeGridCard";
import scrollCalendar from "./scripts/podcasts/scrollCalendar";
import scrollToSpecial from "./scripts/podcasts/scrollToSpecial";
import navPodcast from "./scripts/podcasts/navContentPodcasts";
import replaceSvg from "./scripts/podcasts/replaceSvg";
import specialImage from "./scripts/podcasts/podcastSpecialPlaylist";
import loadUrlSpecial from "./scripts/podcasts/loadUrlSpecial";

startTurboLinks();
utils();
podcastPlayer();

/*

utils();
loadSlider();
//companyParallax();
resizeGridCard();
scrollToSpecial();
headerScrolling();
navPodcast();
//loadSearchPreview();
replaceSvg();
//mainHomePodcastToggle();
specialImage();
loadUrlSpecial();
scrollCalendar();*/

import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";
